import ObjectService from "./Object.service";
const Operators = {
    LESS_THAN: "lessThan",
    GREATER_THAN: "greaterThan",
    LESS_THAN_OR_EQUAL: "lessThanOrEqual",
    GREATER_THAN_OR_EQUAL: "greaterThanOrEqual",
};
/**
 * Validation Helper for Forms
 */
export default class ValidationService {
    static makeClassName(errors, name, className) {
        const hasError = !!ObjectService.getPropertyAtPath(errors, name);
        return (className || "") + (hasError ? " is-invalid" : "");
    }
    static getEmailRegex() {
        return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    }
    /**
     * Helper method comparing two values. If either value is null, returns true.
     *
     * @param {any} value1 - The value to be validated, and compared to value2
     * @param {any} value2 - The value to be compared to value1
     * @param {string} operator - The operator to decide how value1 and value2 are compared
     */
    static _compareTo(value1, value2, operator) {
        // We return true here because if only one value is populated in the form,
        // then we don't need to compare anything
        if (value1 == null || value1 === "" || value2 == null || value2 === "") {
            return true;
        }
        let result;
        switch (operator) {
            case Operators.LESS_THAN:
                result = Number(value1) < Number(value2);
                break;
            case Operators.GREATER_THAN:
                result = Number(value1) > Number(value2);
                break;
            case Operators.LESS_THAN_OR_EQUAL:
                result = Number(value1) <= Number(value2);
                break;
            case Operators.GREATER_THAN_OR_EQUAL:
                result = Number(value1) >= Number(value2);
                break;
            default:
                result = false;
        }
        return result;
    }
    /**
     * Used to validate that one number is less than another in a form.  Does automatic type conversion.
     *
     * @param {any} value1 - The value to be validated and compared as less than value2
     * @param {any} value2 - The value to be compared as greater than value1
     * @param {string} message - The message to return upon invalidation
     */
    static lessThan(value1, value2, message) {
        if (Number.isNaN(value1)) {
            return "Please enter a number";
        }
        return (ValidationService._compareTo(value1, value2, Operators.LESS_THAN) ||
            message);
    }
    /**
     * Used to validate that one number is greater than another in a form.  Does automatic type conversion.
     *
     * @param {any} value1 - The value to be validated and compared as greater than value2
     * @param {any} value2 - The value to be compared as less than value1
     * @param {string} message - The message to return upon invalidation
     */
    static greaterThan(value1, value2, message) {
        if (Number.isNaN(value1)) {
            return "Please enter a number";
        }
        return (ValidationService._compareTo(value1, value2, Operators.GREATER_THAN) ||
            message);
    }
    /**
     * Used to validate that one number is less than or equal to another in a form.  Does automatic type conversion.
     *
     * @param {any} value1 - The value to be validated and compared as less than or equal to value2
     * @param {any} value2 - The value to be compared as greater than or equal to value1
     * @param {string} message - The message to return upon invalidation
     */
    static lessThanOrEqualTo(value1, value2, message) {
        if (Number.isNaN(value1)) {
            return "Please enter a number";
        }
        return (ValidationService._compareTo(value1, value2, Operators.LESS_THAN_OR_EQUAL) || message);
    }
    /**
     * Used to validate that one number is greater than or equal to another in a form.  Does automatic type conversion.
     *
     * @param {any} value1 - The value to be validated and compared as greater than or equal to value2
     * @param {any} value2 - The value to be compared as less than or equal to value1
     * @param {string} message - The message to return upon invalidation
     */
    static greaterThanOrEqualTo(value1, value2, message) {
        if (Number.isNaN(value1)) {
            return "Please enter a number";
        }
        return (ValidationService._compareTo(value1, value2, Operators.GREATER_THAN_OR_EQUAL) || message);
    }
}
